// Imports
  // React
  import { useContext } from 'react';
  // Contexts
  import { CartContext } from '../context/CartContext';
  import { Link } from 'react-router-dom';
  // Components
  import CartItemCard from './CartItemCard';
  import CompleteOrder from './CompleteOrder';




// Component
    const CartItemList = () => {
        
        // Context
        const { items, getPrice, clearItems } = useContext(CartContext);

        // Listar items en el carrito
        function listItemsInCart(){
            // Ordenarlos
            items.sort(function(a, b){
                if(a.name < b.name) {return -1;}
                if(a.name > b.name) {return 1;}
                return 0;
            });
            items.sort(function(a, b){
                if(a.category < b.category) {return -1;}
                if(a.category > b.category) {return 1;}
                return 0;
            });
            // Local Storage
            localStorage.setItem('storagedCart', JSON.stringify(items));
            // Mostrarlos
            return(
                <div className='cart-item-container'>
                    <div className='cart-item-list'>
                        {items.map( i =>
                            <div key={i.name}>
                                <CartItemCard item={i} />
                            </div>
                        )}
                    </div>
                    <div className='cart-total'>
                        <span className="cart-price">Total ${getPrice().toFixed(2)}</span>
                        <button className="cart-button" onClick={order}>Finalizar compra</button>
                        <button className="cart-button" onClick={clearItems}>Vaciar carrito</button>
                    </div>
                </div>
            )
        }

        //Mostrar "completá tu pedido"
        const order = () =>{
            document.getElementsByClassName("completed-order-message")[0].style.display="none"
            document.getElementsByClassName("complete-order-container")[0].style.display="block"
            document.getElementsByClassName('complete-order')[0].classList.add('display-flex-from-right');
        }

        return (
            <>
                {
                    items.length ?
                    (
                        <>
                            {listItemsInCart()}
                        </>
                    ) :
                    <>
                        <div className='cart-item-container'>
                            <div className="cart-item-card">
                                <span>El carrito está vacío</span>
                                <div>
                                    <Link className="cart-item-card-link" to="/tienda/productos">Lo invitamos a recorrer la tienda</Link>
                                </div>
                            </div>
                        </div>
                    </>
                }
                <CompleteOrder />
            </>
            )
    }

    export default CartItemList